export default '/static/frontend/ReachDigital/12gobiking/dist/assets/bonifico-bancario-dccb65fa.png'